export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-130--g3.bf38e05c.png";